import { InlineLoader } from '@dealstack/frontend/shared/components/loaders/InlineLoader/InlineLoader';
import { drawerTransitionProps } from '@dealstack/frontend/shared/mechanism/styleguide/GlobalStyling';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import { StyledDrawer } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ProgrammeSettings/MasterDocuments/styles.ts';
import { EditMasterDocumentBody } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ProgrammeSettings/MasterDocuments/components/EditMasterDocument/EditMasterDocumentBody.tsx';
import { useMasterDocumentQuery } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ProgrammeSettings/MasterDocuments/api/useMasterDocumentQuery';

interface Props {
	opened: boolean;
	documentId: string | null;
	onClose: () => void;
}

export const MasterDocumentSettingsDrawer = ({ opened, documentId, onClose }: Props) => {
	const tMipManage = useTranslationMipManage();

	const { data: selectedDocument, isLoading } = useMasterDocumentQuery(documentId, opened);

	return (
		<StyledDrawer
			opened={opened}
			onClose={onClose}
			position="right"
			size="md"
			transitionProps={drawerTransitionProps}
			trapFocus={false}
			title={tMipManage('master_documents.text.settings_title')}
		>
			{isLoading || !selectedDocument ? (
				<InlineLoader />
			) : (
				<EditMasterDocumentBody editContract={selectedDocument} onDeleteSuccess={onClose} />
			)}
		</StyledDrawer>
	);
};
